import { MutationTree } from 'vuex';
import { FunctionsState } from './types';
import { Functions } from '../../Classes/Entities';

// actionによって変更されるフィールド
export const mutations: MutationTree< FunctionsState> = {

    getKeys: (state, functionMap: Functions) => {
        state.functionMap = functionMap;
        state.status = true;
    },
};

